// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1bRBB","notes":"Notes_notes__2-DQD","note":"Notes_note__1KrE_","markdown":"Notes_markdown__28q58"};